import { parseToHTML } from "@/shared/lib/markdown"

export function safeParseToHTML(markdownLikeText) {
  try {
    return parseToHTML(markdownLikeText);
  } catch (e) {
    console.error("Failed to parse markdown-like text, falling back to plain text.", e);
    const escaped = String(markdownLikeText ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
    return `<p>${escaped}</p>`;
  }
}
